var numbersWithCommas = function (number) {
    if (number >= 1000) {
        return number
            .toString()
            .replace(/,/g, '')
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return number;
};
export var calculateMonthlyCost = function (estimatedMiles, perMileCost) {
    var calculationArray = [];
    var numbers;
    var milesPerMonth = estimatedMiles > 0 ? (estimatedMiles / 12).toFixed(2) : 0;
    if (milesPerMonth) {
        if (parseFloat(milesPerMonth) > 100) {
            var firstNumber = void 0;
            var beforeFirstNumber = void 0;
            beforeFirstNumber =
                Math.floor(parseFloat(milesPerMonth) / 100) * 100 === parseFloat(milesPerMonth)
                    ? Math.floor((parseFloat(milesPerMonth) - 100) / 100) * 100
                    : Math.floor(parseFloat(milesPerMonth) / 100) * 100;
            firstNumber =
                Math.floor((parseFloat(milesPerMonth) - 100) / 100) * 100 < 100
                    ? Math.floor((parseFloat(milesPerMonth) - 10) / 100) * 100 - 10
                    : Math.floor((parseFloat(milesPerMonth) - 100) / 100) * 100;
            if (beforeFirstNumber === firstNumber) {
                if (beforeFirstNumber <= 100) {
                    firstNumber = Math.floor((beforeFirstNumber - 10) / 100) * 100 - 10;
                }
                else {
                    firstNumber = Math.floor((beforeFirstNumber - 100) / 100) * 100;
                }
            }
            numbers = [
                firstNumber > 0 ? firstNumber : false,
                beforeFirstNumber,
                parseFloat(milesPerMonth),
                Math.floor((parseFloat(milesPerMonth) + 100) / 100) * 100,
                Math.floor((parseFloat(milesPerMonth) + 200) / 100) * 100,
            ];
        }
        else if (parseFloat(milesPerMonth) <= 100 && parseFloat(milesPerMonth) > 10) {
            var beforeLastNumber = Math.ceil(parseFloat(milesPerMonth) / 100) * 100 === parseFloat(milesPerMonth)
                ? Math.ceil(parseFloat(milesPerMonth) / 100) * 100 + 100
                : Math.ceil(parseFloat(milesPerMonth) / 100) * 100;
            var lastNumber = Math.ceil(beforeLastNumber / 100) * 100 + 100;
            numbers = [
                Math.round((parseFloat(milesPerMonth) - 20) / 10) * 10,
                Math.round((parseFloat(milesPerMonth) - 10) / 10) * 10,
                parseFloat(milesPerMonth),
                beforeLastNumber,
                lastNumber,
            ];
        }
        else if (parseFloat(milesPerMonth) <= 10) {
            if (parseFloat(milesPerMonth) === 10) {
                numbers = [parseFloat(milesPerMonth), 20, 30, 40];
            }
            else {
                numbers = [parseFloat(milesPerMonth), 10, 20, 30];
            }
        }
        if (numbers) {
            numbers.forEach(function (number) {
                var estimateCost;
                if (number >= 833) {
                    estimateCost = ((833 * perMileCost) / 100).toFixed(2).toString();
                }
                else {
                    estimateCost = ((number * perMileCost) / 100).toFixed(2).toString();
                }
                if (number > 0) {
                    calculationArray.push({
                        estimateMiles: numbersWithCommas(parseInt(number)),
                        estimateCost: estimateCost,
                        active: Math.max(numbers) === number || number === parseFloat(milesPerMonth),
                    });
                }
            });
        }
    }
    return calculationArray;
};
